import qs from 'querystringify'
import remote from './remote'

const URL = {
    ADD: '/cms/promo',
    SEARCH: '/cms/promo',
    DELETE: '/cms/promo',
    UPDATE: '/cms/promo'
}

export default {
    promotionAdd (promotion, uploadProgressHandler) {
        return remote.request({
            url: remote.getUrl(URL.ADD),
            method: remote.METHOD.POST,
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            data: promotion,
            timeout: 3600000,
            onUploadProgress: uploadProgressHandler
        })
    },
    updatePromotion (contentId, promotion, uploadProgressHandler) {
        return remote.request({
          url: remote.getUrl(URL.UPDATE) + '/' + contentId,
          method: remote.METHOD.POST,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          data: promotion,
          timeout: 3600000,
          onUploadProgress: uploadProgressHandler,
        });
    },
    searchPromotion (option) {
        let url = remote.getUrl(URL.SEARCH)

        if (option) {
            url = url + '?' + qs.stringify(option)
        }

        return remote.request({
            url: url,
        })
    },
    searchPromotionDetail (contentId) {
        return remote.request({
            url: remote.getUrl(URL.SEARCH) + '/' + contentId,
        })
    },
    removePromotion (contentId) {
        return remote.request({
            url: remote.getUrl(URL.DELETE),
            method: remote.METHOD.DELETE,
            headers: {
                'Content-Type': 'application/json'
            },
            data: Array.isArray(contentId) ? contentId : [contentId],
        })
    }
}
